interface AiConfigTabShellProps {
  loading: boolean;
  error: string | null;
  children: React.ReactNode;
}

export function AiConfigTabShell({ loading, error, children }: AiConfigTabShellProps) {
  if (loading) return <div className="text-gray-500">Loading...</div>;
  if (error) return <div className="text-red-600">{error}</div>;
  return <>{children}</>;
}
